const Experiencedata = [
  {
    position: "Frontend Developer",
    company: "Softqube Technologies Pvt. Ltd",
    dateduration: "December 2022 - February 2026",
    monthduration: "3 yrs 2 mos",
    detail: [
      "Built scalable SaaS and Single Page Applications (SPA) using React.js with optimized component architecture.",
      "Developed Progressive Web Applications (PWA) with offline support using service workers and caching strategies.",
      "Reduced unnecessary re-renders by ~30% using Redux Toolkit and improved performance (Lighthouse score 90+).",
      "Designed responsive, mobile-first user interfaces using Tailwind CSS and SCSS.",
      "Implemented secure authentication using JWT and OAuth2 with role-based access control.",
      "Integrated RESTful APIs and collaborated with backend teams to improve performance and scalability.",
      "Refactored legacy code to improve maintainability and reduce technical debt.",
      "Used Git for version control (branching, code reviews) and implemented CI/CD pipelines for automated deployment using Vercel.",
      "Worked in Agile/Scrum environment and collaborated with cross-functional teams.",
    ],
    technology: [
      "React.js",
      "Next.js",
      "Redux Toolkit",
      "JavaScript (ES6+)",
      "TypeScript",
      "Tailwind CSS",
      "React Bootstrap",
      "SCSS",
      "Node.js",
      "Express.js",
      "MongoDB",
      "RESTful APIs",
      "JWT",
      "OAuth2",
      "CI/CD",
      "Git",
      "Vercel",
      "Render",
    ],
  },
  {
    position: "Frontend Developer",
    company: "Self-Employed",
    dateduration: "April 2022 - November 2022",
    monthduration: "8 mos",
    detail: [
      "Developed responsive Single Page Applications (SPA) using React.js.",
      "Built Progressive Web Applications (PWA) with offline support and improved performance.",
      "Integrated third-party RESTful APIs for dynamic and data-driven features.",
      "Implemented authentication and authorization workflows in React applications.",
      "Built CRUD APIs using Node.js, Express.js, and MongoDB.",
      "Improved performance and scalability through frontend optimization.",
      // "Delivered end-to-end solutions while managing multiple client projects independently."
    ],
    technology: [
      "React.js",
      "Next.js",
      "Redux Toolkit",
      "JavaScript (ES6+)",
      "TypeScript",
      "Tailwind CSS",
      "React Bootstrap",
      "SCSS",
      "Node.js",
      "Express.js",
      "MongoDB",
      "RESTful APIs",
      "JWT",
      "OAuth2",
      "CI/CD",
      "Git",
      "Vercel",
      "Render",
    ],
  },
  {
    position: "Frontend Developer",
    company: "CodeCaste Pvt. Ltd",
    dateduration: "February 2021 - April 2022",
    monthduration: "1 yr 3 mos",
    detail: [
      "Developed scalable React-based web applications.",
      "Built responsive, mobile-first user interfaces.",
      "Worked with REST APIs and improved UI performance.",
      "Handled multiple client projects and ensured timely delivery.",
      "Collaborated with designers and developers to deliver production-ready solutions.",
    ],
    technology: [
      "React.js",
      "JavaScript",
      "HTML5",
      "CSS3",
      "SCSS",
      "React Bootstrap",
      "REST APIs",
    ],
  },
];

export default Experiencedata;
